import React, { useState, useEffect, forwardRef } from 'react';
import { Toast } from 'zarm';
import { getState } from '@/store';
import { getQueryParam } from '@/utils/tool';
import { queryNotice } from '@/services/supervision';
import InfoContent from '../content/index';
import './index.less';
const TabContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    content = {},
    tabValue,
    onScroll
  } = props;
  const [healthNotices, setHealthNotices] = useState({
    noticeDetailList: []
  });
  const [insureNotices, setInsureNotices] = useState({});
  const [specialAgreement, setSpecialAgreement] = useState({});
  const [contentFiles, setFiles] = useState({});
  const {
    relation = 'healthNotice',
    noticeObjectType,
    files = []
  } = content;
  useEffect(() => {
    if (relation === 'healthNotice') {
      const currentPlan = getState('PLAN_ID') || getState('currentPlan');
      const {
        promotionId = ''
      } = getQueryParam() || {};
      queryNotice({
        noticeType: relation,
        planId: currentPlan,
        promotionId,
        noticeObjectType
      }).then(res => {
        const {
          success,
          result,
          message
        } = res;

        if (!success) {
          Toast.show(message || '网络错误');
          return;
        }

        setHealthNotices(result);
      });
      return;
    }

    if (relation === 'files') {
      // console.log('file==>', files);
      const {
        id
      } = files[0] || {};

      if (!id) {
        setFiles({});
        return;
      } // console.log(files?.[0]?.content);


      setFiles(files === null || files === void 0 ? void 0 : files[0]); // fetchFileById({
      //   id,
      // }).then((res) => {
      //   console.log(res);
      //   const { message, success, result = {} } = res;
      //   if (!success) {
      //     Toast.show(message || '网络异常，请稍后重试');
      //   } else {
      //     const { content, type } = result;
      //     setFiles(result);
      //   }
      // });
    }

    if (relation === 'insureNotice') {
      const currentPlan = getState('PLAN_ID') || getState('currentPlan');
      queryNotice({
        noticeType: relation,
        planId: currentPlan,
        noticeObjectType
      }).then(res => {
        const {
          success,
          result,
          message
        } = res;

        if (!success) {
          Toast.show(message || '网络错误');
          return;
        }

        setInsureNotices(result);
      });
      return;
    }

    if (relation === 'specialAgreement') {
      const currentPlan = getState('PLAN_ID') || getState('currentPlan');
      queryNotice({
        noticeType: relation,
        planId: currentPlan
      }).then(res => {
        const {
          success,
          result,
          message
        } = res;

        if (!success) {
          Toast.show(message || '网络错误');
          return;
        }

        setSpecialAgreement(result);
      });
    }
  }, [content]);

  if (relation === 'healthNotice') {
    // const { header = '', noticeDetailList = [] } = healthNotices || {};
    return /*#__PURE__*/React.createElement("div", {
      className: "c-tabContent",
      ref: ref,
      onScroll: onScroll
    }, /*#__PURE__*/React.createElement(InfoContent, {
      notice: healthNotices,
      tabValue: tabValue
    }));
  }

  if (relation === 'files') {
    const {
      content: _content = ''
    } = contentFiles || {};
    return /*#__PURE__*/React.createElement("div", {
      className: "c-tabContent",
      ref: ref,
      onScroll: onScroll
    }, /*#__PURE__*/React.createElement(InfoContent, {
      notice: {
        header: '',
        noticeDetailList: [{
          noticeContent: _content
        }]
      },
      tabValue: tabValue
    }));
  }

  if (relation === 'insureNotice') {
    const {
      smartQuestionType,
      header = '',
      noticeDetailList = []
    } = insureNotices || {};
    const notice = {
      header: '',
      noticeDetailList: []
    };

    if (smartQuestionType === 'third') {
      notice.header = header;
      notice.noticeDetailList = noticeDetailList;
      return /*#__PURE__*/React.createElement("div", {
        className: "c-tabContent",
        ref: ref,
        onScroll: onScroll
      }, /*#__PURE__*/React.createElement(InfoContent, {
        notice: notice,
        tabValue: tabValue
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "c-tabContent",
      ref: ref,
      onScroll: onScroll
    }, /*#__PURE__*/React.createElement(InfoContent, {
      notice: notice
    }));
  }

  if (relation === 'specialAgreement') {
    // const { header = '', noticeDetailList = [] } = specialAgreement || {};
    return /*#__PURE__*/React.createElement("div", {
      className: "c-tabContent",
      ref: ref,
      onScroll: onScroll
    }, /*#__PURE__*/React.createElement(InfoContent, {
      notice: specialAgreement,
      tabValue: tabValue
    }));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "c-tabContent-com"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ql-editor",
    dangerouslySetInnerHTML: {
      __html: ''
    }
  })));
});
TabContent.displayName = 'TabContent';
export default TabContent;